import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { useTranslation } from 'react-i18next';
import { colors, MailIcon } from '@aftersale-next/ui';
import ChannelOptionButton from './elements/channel-option-button';
export default function EmailOption(_ref) {
  var onClick = _ref.onClick;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  return /*#__PURE__*/_jsx(ChannelOptionButton, {
    label: t('EMAIL'),
    Icon: /*#__PURE__*/_jsx(MailIcon, {}),
    accent: colors.appBackground,
    onClick: onClick
  });
}